module.exports = function() {
  return new Worker(__webpack_public_path__ + "7f882f0fa45ad5425738.worker.js");
};